"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndOfBudgetPlanNotificationSchema = exports.StartOfBudgetPlanNotificationSchema = exports.BudgetExhaustedNotificationSchema = exports.EndOfBudgetPlanNotificationPayloadSchema = exports.StartOfBudgetPlanNotificationPayloadSchema = exports.BudgetExhaustedNotificationPayloadSchema = void 0;
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.BudgetExhaustedNotificationPayloadSchema = (0, core_1.StrictObject)({
    budgetPlanId: core_1.IdSchema,
    campaignId: core_1.IdSchema,
    campaignName: core_1.NameSchema,
    teamId: core_1.IdSchema,
    teamName: core_1.NameSchema,
}, {
    title: "Budget exhausted notification payload",
    description: "Payload type used to notify that budget has been exhausted.",
});
exports.StartOfBudgetPlanNotificationPayloadSchema = (0, core_1.StrictObject)({
    budgetPlanId: core_1.IdSchema,
    start: core_1.TimestampSchema,
    end: core_1.TimestampSchema,
    campaignId: core_1.IdSchema,
    campaignName: core_1.NameSchema,
    teamId: core_1.IdSchema,
    teamName: core_1.NameSchema,
}, {
    title: "Budget plan started notification payload",
    description: "Payload type detailing when a budget plan starts and ends",
});
exports.EndOfBudgetPlanNotificationPayloadSchema = (0, core_1.StrictObject)({
    start: core_1.TimestampSchema,
    end: core_1.TimestampSchema,
    budgetPlanId: core_1.IdSchema,
    campaignId: core_1.IdSchema,
    campaignName: core_1.NameSchema,
    teamId: core_1.IdSchema,
    teamName: core_1.NameSchema,
}, {
    title: "Budget plan ended notification payload",
    description: "Payload type detailing when a budget plan starts and ends",
});
exports.BudgetExhaustedNotificationSchema = (0, ruby_1.createNotificationMessageSchema)(ruby_1.NotificationType.BUDGETS_BUDGET_PLAN_EXHAUSTED, exports.BudgetExhaustedNotificationPayloadSchema, {
    title: "Budget exhausted notification",
    description: "Notification message schema of message to be sent when a budget plans budget has been exhausted.",
});
exports.StartOfBudgetPlanNotificationSchema = (0, ruby_1.createNotificationMessageSchema)(ruby_1.NotificationType.BUDGETS_BUDGET_PLAN_STARTED, exports.StartOfBudgetPlanNotificationPayloadSchema, {
    title: "Budget plan started notification",
    description: "Notification message to be sent on the first day of a budget plan.",
});
exports.EndOfBudgetPlanNotificationSchema = (0, ruby_1.createNotificationMessageSchema)(ruby_1.NotificationType.BUDGETS_BUDGET_PLAN_ENDED, exports.EndOfBudgetPlanNotificationPayloadSchema, {
    title: "Budget plan ended notification",
    description: "Notification message to be sent on the final day of a budget plan.",
});
